// Kid-facing app home — mounts the DNF maths engine. Footer escape hatch → Grown-Ups' Corner.
import { Link } from "react-router-dom";
import MathsGame from "../game/MathsGame.jsx";

export default function KidHome() {
  return (
    <>
      <MathsGame />
      <p
        className="no-print"
        style={{ position: "fixed", right: 12, bottom: 12, margin: 0, zIndex: 10 }}
      >
        <Link to="/grown-ups">Grown-Ups' Corner</Link>
      </p>
    </>
  );
}
